import {type ReactNode} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {Outlet} from "react-router-dom";

import {auth} from "~/firebase/firebase";

export const ProtectedRoute = (): ReactNode => {
  const [user] = useAuthState(auth);

  if (user === null || user === undefined) return <></>;

  return <Outlet />;
};
